/**
 * File d'attente Firestore : sendPasswordResetEmail envoie le courriel via Resend.
 */
import { collection, addDoc, onSnapshot } from 'firebase/firestore';
import { firestore } from '../config/firebase';

const COLLECTION = 'passwordResetEmails';
const STATUS_WAIT_MS = 20000;

/**
 * @param {string} email
 * @param {'fr'|'en'} [locale='fr']
 */
export async function requestPasswordResetEmail(email, locale = 'fr') {
  const normalized = String(email || '').trim().toLowerCase();
  if (!normalized) throw new Error('email required');

  const docRef = await addDoc(collection(firestore, COLLECTION), {
    email: normalized,
    locale: locale === 'en' ? 'en' : 'fr',
    status: 'pending',
    createdAt: new Date(),
  });

  await new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      unsub();
      reject(new Error('timeout'));
    }, STATUS_WAIT_MS);

    const unsub = onSnapshot(
      docRef,
      (snap) => {
        const status = snap.data()?.status;
        if (status === 'pending') return;
        clearTimeout(timeout);
        unsub();
        if (status === 'sent') resolve();
        else reject(new Error(snap.data()?.error || 'send failed'));
      },
      (err) => {
        clearTimeout(timeout);
        unsub();
        reject(err);
      }
    );
  });
}
